import { render } from "./employee-edit-model.vue?vue&type=template&id=f55e487c&scoped=true"
import script from "./employee-edit-model.vue?vue&type=script&lang=js"
export * from "./employee-edit-model.vue?vue&type=script&lang=js"

import "./employee-edit-model.vue?vue&type=style&index=0&id=f55e487c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55e487c"]])

export default __exports__